'use client';

import { c as _c } from "react/compiler-runtime";
import { StyleProvider } from '@ant-design/cssinjs';
import type { ReactNode } from 'react';
import { SolanaProvider } from '@/SolanaProvider';
import { ConfigProvider } from '@/utils/antd-imports';
import { AirdropShareProvider } from './shared/providers/AirdropShareProvider';
import { CelebrityShareProvider } from './shared/providers/CelebrityShareProvider';
import { FirstTimePeriodEntryModalProvider } from './shared/providers/FirstTimePeriodEntryModalProvider';
import { LeaderboardShareProvider } from './shared/providers/LeaderboardShareProvider';
import { ShareRewardProvider } from './shared/providers/ShareRewardProvider';
import { BreakpointsProvider } from './shared/Utils/BreakpointsProviderClient';
import { BroadcastChannelProvider } from './shared/Utils/BroadcastChannelProviderClient';
import AntdThemeConfig from './styles/antd-theme';
interface ProvidersProps {
  children: ReactNode;
}
export const Providers = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <SolanaProvider><BroadcastChannelProvider><BreakpointsProvider><FirstTimePeriodEntryModalProvider><ShareRewardProvider><CelebrityShareProvider><AirdropShareProvider><LeaderboardShareProvider><StyleProvider layer={true} hashPriority="high"><ConfigProvider theme={AntdThemeConfig}>{children}</ConfigProvider></StyleProvider></LeaderboardShareProvider></AirdropShareProvider></CelebrityShareProvider></ShareRewardProvider></FirstTimePeriodEntryModalProvider></BreakpointsProvider></BroadcastChannelProvider></SolanaProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};